"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3244],{

/***/ 63244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ CruiseScheduleList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/utils/DateUtil.ts
var DateUtil = __webpack_require__(16341);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./main/javascripts/components/button/AButton.tsx
var AButton = __webpack_require__(65644);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseScheduleListItem.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var CruiseScheduleListItem = function CruiseScheduleListItem(props) {
  var uniqueId = props.uniqueId,
      schedule = props.schedule,
      _props$hideDetailButt = props.hideDetailButton,
      hideDetailButton = _props$hideDetailButt === void 0 ? false : _props$hideDetailButt;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component", "label", "unit"]),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var formatDate = function formatDate(dateString) {
    var date = (0,DateUtil/* parseDate */.s)(dateString);

    if ((0,isValid["default"])(date)) {
      return (0,format["default"])(date, i18n.language === "ja" ? "yyyy/MM/dd" : "MMMM d, yyyy");
    }

    return dateString;
  };

  var params = {
    departure_date: schedule.departureDate
  };
  var paramsString = (0,lib.stringify)(params);
  var showPagePath = "/cruises/".concat(uniqueId, "?").concat(paramsString);
  var value = schedule.price;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: itemStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: dateStyle,
      children: t("cruise.departureOn", {
        date: formatDate(schedule.departureDate)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: priceButtonBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: priceStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Trans/* Trans */.c, {
          i18nKey: "unit:priceStartsAt",
          values: {
            value: value
          },
          children: ["from", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: priceValueStyle,
            children: value
          }), " p.p."]
        })
      }), !hideDetailButton && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: buttonBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AButton/* AButton */.a, {
          type: "button",
          styleKey: "buttonSmall",
          href: showPagePath,
          target: "_blank",
          rel: "noopener",
          children: t("label:common.showDetail")
        })
      })]
    })]
  });
};
var itemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, ";display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";&:first-of-type{border-top:0;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var dateStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.mediumHeadline2 */.Nv.mediumHeadline2, ";min-width:8rem;font-variant-numeric:tabular-nums;color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var priceButtonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;gap:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";align-items:center;justify-content:flex-end;margin-left:auto;color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var priceStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";min-width:9rem;text-align:right;" + ( true ? "" : 0),  true ? "" : 0);
var priceValueStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.mediumHeadline2 */.Nv.mediumHeadline2, ";font-variant-numeric:tabular-nums;font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle =  true ? {
  name: "1wcbmze",
  styles: "min-width:8rem"
} : 0;
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseScheduleList.tsx











var CruiseScheduleList = function CruiseScheduleList(props) {
  var cruise = props.cruise,
      limit = props.limit,
      hideDetailButton = props.hideDetailButton;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component", "label", "unit"]),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useState = (0,react.useState)(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var initialShowCount = 2;
  var schedules = limit ? (cruise.cruiseSchedules || []).slice(0, limit) : cruise.cruiseSchedules || [];

  var onExpandButtonClick = function onExpandButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  var formatDate = function formatDate(dateString) {
    var date = (0,DateUtil/* parseDate */.s)(dateString);

    if ((0,isValid["default"])(date)) {
      return (0,format["default"])(date, i18n.language === "ja" ? "yyyy/MM/dd" : "MMMM d, yyyy");
    }

    return dateString;
  };

  if (schedules.length === 0) {
    return null;
  }

  var expandButtonText = t("button:common.showLess");
  var expandButtonStyles = expandCloseButtonStyle;

  if (!isExpanded && schedules.length > initialShowCount) {
    var dateString = formatDate(schedules[initialShowCount].departureDate);
    expandButtonText = t("button:cruise.showDeparturesStartingFrom", {
      date: dateString
    });
    expandButtonStyles = expandButtonStyle;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [schedules.map(function (schedule, index) {
      if (!isExpanded && index >= initialShowCount) {
        return null;
      }

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseScheduleListItem, {
        uniqueId: cruise.uniqueId,
        schedule: schedule,
        hideDetailButton: hideDetailButton
      }, schedule.id);
    }), schedules.length > initialShowCount && !hideDetailButton && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: expandButtonBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        css: expandButtonStyles,
        onClick: onExpandButtonClick,
        children: expandButtonText
      })
    })]
  });
};
var expandButtonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";display:flex;justify-content:center;border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var expandButtonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom0_5x */.D.atom0_5x, " 0;border-bottom:1px solid;margin-bottom:", spaceStyle/* space.atom */.D.atom, ";cursor:pointer;transition:opacity 0.3s ease;&:hover{opacity:0.8;}&::before{content:\"\";position:absolute;top:50%;right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";display:block;width:0.5rem;height:0.5rem;border:1px solid;border-left:0;border-bottom:0;transform:translateY(-75%) rotate(135deg);transition:transform 0.3s ease;}" + ( true ? "" : 0),  true ? "" : 0);
var expandCloseButtonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)(expandButtonStyle, ";&::before{transform:translateY(-25%) rotate(-45deg);}" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);